import { LightBoxOfferInfoDtoSchema } from "@modules/boxOffer/gateway/boxOfferDto"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { PromoCodeStatus } from "@modules/promoCode/gateway/promoCodeDto"
import { z } from "zod"

export const BoxPromoCodeDtoSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    code: z.string(),
    type: z.enum(CouponType),
    value: z.number(),
    createdAt: z.iso.datetime(),
    startAt: z.iso.datetime().nullable(),
    expirationDate: z.iso.datetime().nullable(),
    durationInMonths: z.number().nullable(),
    maxAttendees: z.number().nullable(),
    onlyNewCustomer: z.boolean(),
    archived: z.boolean(),
    archivedStatus: z.enum(PromoCodeStatus).nullable(),
    boxOffers: z.array(LightBoxOfferInfoDtoSchema),
  })
  .meta({ id: "BoxPromoCodeDtoSchema" })

export type BoxPromoCodeDto = z.infer<typeof BoxPromoCodeDtoSchema>
